var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgShop(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 27,
    height: 26,
    viewBox: "0 0 27 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.75 2.16675L3.375 6.50008V21.6667C3.375 22.2414 3.61205 22.7925 4.03401 23.1988C4.45597 23.6051 5.02826 23.8334 5.625 23.8334H21.375C21.9717 23.8334 22.544 23.6051 22.966 23.1988C23.3879 22.7925 23.625 22.2414 23.625 21.6667V6.50008L20.25 2.16675H6.75Z",
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M3.375 6.5H23.625",
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M18 10.8333C18 11.9825 17.5259 13.0847 16.682 13.8974C15.8381 14.71 14.6935 15.1666 13.5 15.1666C12.3065 15.1666 11.1619 14.71 10.318 13.8974C9.47411 13.0847 9 11.9825 9 10.8333",
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShop);
export default __webpack_public_path__ + "static/media/shop.2fa1f692b2cbc2d9e0be677b83757df1.svg";
export { ForwardRef as ReactComponent };